export default class ProjectLastSectionFirstTypeTranslations {
    constructor(projects) {
        const { id, work_details } = projects;
        this.id = id;
        this.work_details = work_details;
    }
}
